import { render, staticRenderFns } from "./StatusLabel.vue?vue&type=template&id=a18badc4&"
import script from "./StatusLabel.vue?vue&type=script&lang=js&"
export * from "./StatusLabel.vue?vue&type=script&lang=js&"
import style0 from "./StatusLabel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports